import { render, staticRenderFns } from "./ExamsMocktests.vue?vue&type=template&id=e1f2a8e8&"
import script from "./ExamsMocktests.vue?vue&type=script&lang=js&"
export * from "./ExamsMocktests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports